import Layout from './comps/layout/Layout';
import { Route, Routes } from 'react-router-dom';
import Join from './comps/join/Join';
import Activation from './comps/activation/Activation';
import LandingPage from './comps/landing/LandingPage';
import Land2 from './comps/landing/land2/Land2';
import Land3 from './comps/landing/land3/Land3';
import Land4 from './comps/landing/land4/Land4';
import TokensContextProvider from './providers/TokensContextProvider';
import OperatorContextProvider from './comps/login/OperatorContextProvider';
import Rogue from './comps/layout/rogue/Rogue';
import RogueOperator from './comps/layout/rogue/RogueOperator';
import ConfigPathContextProvider from './providers/ConfigPathContextProvider';
import BreadCrumbsContextProvider from './providers/BreadCrumbsContextProvider';
import './App.css';

// export const SelectorAboveRoot =  /^\$\.rootAccount\.apps(\['[^']+'\]){7}.+/;
// Example for repeating folder names
// ^ab(\['[^']+'\]){3}$    

function App() {
  return (    
    <div className='App'>
      <TokensContextProvider>
        <OperatorContextProvider>
          <ConfigPathContextProvider>
            <BreadCrumbsContextProvider>

      
                <Routes>
                  <Route element={<Rogue />} >
                    <Route path='/rogue' element={<RogueOperator />}  key='/rogue' />
                    <Route path='/land4' element={<Land4 />}          key='/land4'/>
                  </Route>

                  <Route exact path='/join/:jcode' element={<Join/>}          key='/join'/>
                  <Route exact path='/act/:acode'  element={<Activation />}   key='/activation'/>
                  <Route       path='/landing'     element={<LandingPage />}  key='/landing'/>
                  <Route       path='/land2'       element={<Land2 />}        key='/land2'/>
                  <Route       path='/land3'       element={<Land3 />}        key='/land3'/>
                  <Route       path='/*'           element={<Layout/>}        key='/layout'/>
                </Routes>      

            </BreadCrumbsContextProvider>
          </ConfigPathContextProvider>
        </OperatorContextProvider>
      </TokensContextProvider>
       
    </div>        
  );
}

export default App;
